export default __webpack_public_path__ + "static/media/006-rocking horse.53c3d800.svg";